import _ from 'lodash'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

const defaultFilterData = {
  gender: null,
  educationalBackground: null,
  employed: null,
  hasCareerResumes: false,
  address: { prefectures: [], cities: [], selectedOption: null },
  excludesDisabledScout: undefined,
  userId: null,
  searchConditionName: ''
}

const defaultFilterDataScouted = {
  ...defaultFilterData,
  sendDate: {
    from: '',
    to: ''
  },
  sendCount: null,
  readingStatus: '',
  subject: '',
  isResendable: false,
  specialFavorIds: [],
  reservedInfo: ''
}

export default {
  data () {
    return {
      filterData: {},
      filterMemberObjects: [],
      renderModal: true
    }
  },
  created () {
    this.$set(this, 'filterData', _.cloneDeep(this.isScouted ? defaultFilterDataScouted : defaultFilterData))
  },
  computed: {
    ...mapGetters('contracts', [
      'canScoutResend'
    ]),
    searchConditionNames () {
      return _(this.memberObjects).map(_.property('member.searchConditionName')).uniq().compact().map(v => {
        return { id: v, name: v }
      }).value()
    }
  },
  watch: {
    filterData: {
      handler () {
        this.filter()
      },
      deep: true
    },
    'memberObjects' () {
      this.filter()
    }
  },
  methods: {
    sendDateFromFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => _.get(memberObject, 'member.scout.latestMessage.insertDate') &&
        dayjs(memberObject.member.scout.latestMessage.insertDate).startOf('day').isSameOrAfter(this.filterData.sendDate.from))
    },
    sendDateToFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => _.get(memberObject, 'member.scout.latestMessage.insertDate') &&
        dayjs(memberObject.member.scout.latestMessage.insertDate).startOf('day').isSameOrBefore(this.filterData.sendDate.to))
    },
    userIdFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => String(_.get(memberObject, 'member.id')).match('^' + this.filterData.userId))
    },
    sendCountFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => _.get(memberObject, 'member.scout.messagesCount') === this.filterData.sendCount)
    },
    readFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => !_.isEmpty(_.get(memberObject, 'member.scout.latestMessage.readDate')))
    },
    noReadFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => _.isEmpty(_.get(memberObject, 'member.scout.latestMessage.readDate')))
    },
    searchConditionNameFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => _.get(memberObject, 'member.searchConditionName') === this.filterData.searchConditionName)
    },
    subjectFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => _.get(memberObject, 'member.scout.latestMessage.subject') === this.filterData.subject)
    },
    resendableFilter (filterMemberObjects) {
      return this.excludesDisabledScoutFilter(filterMemberObjects).filter(memberObject =>
        !memberObject.member.isScoutReserved &&
        !(memberObject.member.isScoutDecline && this.canScoutResend(this.$route.params.contractId, this.$route.params.jobId)) && !memberObject.member.isScoutedToday
      )
    },
    excludesDisabledScoutFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => _.isEmpty(memberObject.member.withdrawDate) && memberObject.member.subscriptions.scout &&
      !memberObject.member.isEntry && !memberObject.member.isScoutRejection &&
      !memberObject.member.isScoutExcluded)
    },
    specialFavorFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => _.get(memberObject, 'member.scout.specialFavors', []).some(specialFavor => _.includes(this.filterData.specialFavorIds, specialFavor.id + '')))
    },
    genderFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => memberObject.member.gender.id === this.filterData.gender)
    },
    educationalBackgroundFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => memberObject.member.educationalBackground && memberObject.member.educationalBackground.id <= this.filterData.educationalBackground)
    },
    employedFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => memberObject.member.employed === this.filterData.employed.toString())
    },
    isMatchPrefectures (memberObject) {
      return memberObject.member.presentAddressPrefecture && this.filterData.address.prefectures.some(presentAddressPrefectureId => presentAddressPrefectureId === memberObject.member.presentAddressPrefecture.id)
    },
    isMatchCities (memberObject) {
      return memberObject.member.presentAddressCity && this.filterData.address.cities.some(presentAddressCityId => presentAddressCityId === memberObject.member.presentAddressCity.id)
    },
    presentAddressFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => this.isMatchPrefectures(memberObject) || this.isMatchCities(memberObject))
    },
    presentAddressPrefectureFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => this.isMatchPrefectures(memberObject))
    },
    presentAddressCityFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => this.isMatchCities(memberObject))
    },
    careerResumeFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => memberObject.member.hasCareerResume)
    },
    reservedInfoFilter (filterMemberObjects) {
      return filterMemberObjects.filter(memberObject => _.get(memberObject, 'member.reservationLogs').includes(this.filterData.reservedInfo))
    },
    filter () {
      let filterMemberObjects = _(this.memberObjects)
      // 全画面：userId （該当数が一気に減るので先頭でフィルタする）
      filterMemberObjects = this.filterData.userId ? this.userIdFilter(filterMemberObjects) : filterMemberObjects

      // スカウト済み一覧関連フィルタ
      filterMemberObjects = _.get(this.filterData, 'subject') ? this.subjectFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = _.get(this.filterData, 'sendDate.from') ? this.sendDateFromFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = _.get(this.filterData, 'sendDate.to') ? this.sendDateToFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = _.get(this.filterData, 'sendCount') ? this.sendCountFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = _.get(this.filterData, 'readingStatus') === '1' ? this.readFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = _.get(this.filterData, 'readingStatus') === '2' ? this.noReadFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = _.get(this.filterData, 'isResendable') ? this.resendableFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = _.toArray(_.get(this.filterData, 'specialFavorIds')).length ? this.specialFavorFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = _.get(this.filterData, 'reservedInfo') ? this.reservedInfoFilter(filterMemberObjects) : filterMemberObjects

      // それ以外のフィルタ（ほぼ全画面で利用される）
      filterMemberObjects = this.filterData.searchConditionName ? this.searchConditionNameFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = this.filterData.gender ? this.genderFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = this.filterData.educationalBackground ? this.educationalBackgroundFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = this.filterData.employed !== null ? this.employedFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = this.filterData.hasCareerResumes ? this.careerResumeFilter(filterMemberObjects) : filterMemberObjects
      filterMemberObjects = (this.isCandidate && this.filterData.excludesDisabledScout) ? this.excludesDisabledScoutFilter(filterMemberObjects) : filterMemberObjects
      if (this.filterData.address.prefectures.length && this.filterData.address.cities.length) {
        filterMemberObjects = this.presentAddressFilter(filterMemberObjects)
      } else {
        filterMemberObjects = this.filterData.address.prefectures.length ? this.presentAddressPrefectureFilter(filterMemberObjects) : filterMemberObjects
        filterMemberObjects = this.filterData.address.cities.length ? this.presentAddressCityFilter(filterMemberObjects) : filterMemberObjects
      }

      this.$set(this, 'filterMemberObjects', filterMemberObjects.value())
      this.$emit('setMemberObjects', this.filterMemberObjects)
    },
    clearFilterData () {
      this.$set(this, 'filterData', _.cloneDeep(this.isScouted ? defaultFilterDataScouted : defaultFilterData))
      this.$set(this.filterData, 'excludesDisabledScout', (this.isCandidate) ? false : undefined)
      this.rerender()
    },
    rerender () {
      // モーダル初期化のため
      this.$set(this, 'renderModal', false)
      this.$nextTick(() => {
        this.$set(this, 'renderModal', true)
      })
    }
  }
}
